import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLeadMagnet, postSoftwareAuditForm } from "../api/utils";
import useFetch from "../api/hooks/useFetch";
import cogoToast from "cogo-toast";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";

export default function SoftwareAudit() {
  const slug = "sggvhgvhsws";
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    needsGstInvoice: false,
    gstNumber: "",
    companyName: "",
    nicheType: "",
    industry_other: "",
  });
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState("Pending");
  const [paymentLink, setPaymentLink] = useState(null);

  const [isWebinarExpired, setIsWebinarExpired] = useState(false);

  const nicheTypes = [
    "Manufacturing & Industrial",
    "Technology & Software",
    "Professional Services",
    "Retail & E-commerce",
    "Construction & Real Estate",
    "Logistics & Supply Chain",
    "Energy & Utilities",
    "Healthcare & Life Sciences",
    "Education & Nonprofit",
    "Finance & Insurance",
    "Media, Entertainment & Hospitality",
    "Other",
  ];
  const {
    apiData: leadMagnet,
    isLoading: isLeadMagnetLoading,
    error: leadMagnetError,
  } = useFetch(getLeadMagnet, slug);

  useEffect(() => {
    if (leadMagnetError) {
      cogoToast.error("Failed to load content");
    } else if (leadMagnet?.status === "error") {
      cogoToast.error("Failed to load content");
    }
  }, [leadMagnetError, leadMagnet]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const submitLeadForm = async () => {
    const {
      name,
      email,
      phone,
      needsGstInvoice,
      gstNumber,
      companyName,
      nicheType,
      industry_other,
    } = formData;

    // Basic validation
    if (!name.trim() || !email.trim() || !phone.trim() || !nicheType) {
      setShowError(true);
      cogoToast.info("Please fill in all required fields");
      return;
    }

    if (nicheType === "Other" && !industry_other.trim()) {
      setShowError(true);
      cogoToast.error("Please specify your niche when selecting 'Other'");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setShowError(true);
      cogoToast.error("Please enter a valid email address");
      return;
    }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      setShowError(true);
      cogoToast.error("Phone number must be exactly 10 digits");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        name,
        email,
        phone,
        slug,
        offering_type: leadMagnet?.offering_type,
        industry_other: nicheType === "Other" ? industry_other : null,
      };

      const response = await postSoftwareAuditForm(payload);

      if (response.status === "ok") {
        if (leadMagnet?.offering_type === "Software Audit") {
          setFormData({
            name: "",
            email: "",
            phone: "",
            nicheType: "",
            industry_other: "",
          });
          setShowError(false);
        }
      } else {
        cogoToast.error(
          response.message || "Something went wrong. Please try again."
        );
      }
    } catch (err) {
      console.error("Form submission error:", err);
      cogoToast.error("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLeadMagnetLoading) {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <main className="wrapper">
        <section className="page-hero-sec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="row justify-content-center">
                <div className="col-lg-6 pb-5">
                  <h4 className="tc-primary head-font text-center pb-1">
                    {leadMagnet?.title}
                  </h4>
                  <h6 className="tc-primary head-font text-center pb-5">
                    {leadMagnet?.subtitle}
                  </h6>
                  {/* <p className="tc-primary fs-24" style={{ textAlign: "justify" }}>
                    {leadMagnet?.subtitle}
                  </p> */}
                </div>
              </div>

              <div className="col-lg-6 col-md-8">
                <div className="row">
                  <div className="col-lg-12">
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      error={showError && !formData.name.trim()}
                      helperText={
                        showError && !formData.name.trim()
                          ? "Name is required"
                          : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 200 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      error={
                        showError &&
                        (!formData.email.trim() ||
                          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
                      }
                      helperText={
                        showError && !formData.email.trim()
                          ? "Email is required"
                          : showError &&
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                          ? "Invalid email format"
                          : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 200 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <TextField
                      fullWidth
                      label="Phone Number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      error={
                        showError &&
                        (!formData.phone.trim() ||
                          !/^\d{10}$/.test(formData.phone))
                      }
                      helperText={
                        showError && !formData.phone.trim()
                          ? "Phone is required"
                          : showError && !/^\d{10}$/.test(formData.phone)
                          ? "Must be 10 digits"
                          : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <Select
                      fullWidth
                      name="nicheType"
                      value={formData.nicheType}
                      onChange={handleInputChange}
                      displayEmpty
                      error={showError && !formData.nicheType}
                      sx={{
                        "& .MuiSelect-select": {
                          background: "#e0e5ef",
                          padding: "12px 14px",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#e0e5ef",
                          },
                          "&:hover fieldset": {
                            borderColor: "#b0b5bf",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3f51b5",
                          },
                        },
                      }}
                      inputProps={{
                        "aria-label": "Industry Type",
                      }}
                    >
                      <MenuItem value="" disabled>
                        Industry Type
                      </MenuItem>
                      {nicheTypes.map((type) => (
                        <MenuItem
                          key={type}
                          value={type}
                          sx={{ padding: "8px 16px" }}
                        >
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                    {showError && !formData.nicheType && (
                      <p
                        style={{
                          color: "#d32f2f",
                          fontSize: "0.75rem",
                          margin: "3px 14px 0",
                        }}
                      >
                        Industry type is required
                      </p>
                    )}
                  </div>

                  {formData.nicheType === "Other" && (
                    <div className="col-lg-12 mt-3">
                      <TextField
                        fullWidth
                        variant="outlined"
                        label="Specify Your Industry"
                        name="industry_other"
                        value={formData.industry_other}
                        onChange={handleInputChange}
                        error={
                          showError &&
                          formData.nicheType === "Other" &&
                          !formData.industry_other.trim()
                        }
                        helperText={
                          showError &&
                          formData.nicheType === "Other" &&
                          !formData.industry_other.trim()
                            ? "Please specify your industry"
                            : ""
                        }
                        required={formData.nicheType === "Other"}
                        margin="normal"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#e0e5ef",
                            },
                            "&:hover fieldset": {
                              borderColor: "#b0b5bf",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3f51b5",
                            },
                            "& input": {
                              background: "#e0e5ef",
                              padding: "12px 14px",
                            },
                          },
                        }}
                        inputProps={{ maxLength: 100 }}
                      />
                    </div>
                  )}

                  <div className="col-lg-12 mt-4">
                    <button
                      onClick={submitLeadForm}
                      disabled={isSubmitting}
                      className="link_btn mt-4 mx-auto"
                      style={{ marginBottom: 50 }}
                    >
                      Submit Audit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
